import React from "react";
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";
import "../../../../styles/TrainingDetailsModal.css";

const TrainingDetailsModal = ({ isOpen, onClose, training, onEdit, onDelete }) => {
    const { t } = useTranslation(['calendar', 'common']);

    if (!isOpen || !training) return null;

    const startTime = dayjs(training.startTime);
    const endTime = dayjs(training.endTime);
    const duration = endTime.diff(startTime, 'minute');

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('tdm-overlay')) {
            onClose();
        }
    };

    return (
        <div className="tdm-overlay" onClick={handleOverlayClick}>
            <div className="tdm-modal">
                {/* Header */}
                <div className="tdm-header">
                    <h2 className="tdm-title">{t('details.trainingDetails')}</h2>
                    <p className="tdm-subtitle">
                        {startTime.format('DD.MM.YYYY')} • {startTime.format('HH:mm')} - {endTime.format('HH:mm')}
                    </p>
                    <button className="tdm-close-btn" onClick={onClose}>✕</button>
                </div>

                {/* Content */}
                <div className="tdm-content">
                    {/* Dog Information */}
                    <div className="tdm-section">
                        <h3 className="tdm-section-title">{t('details.dogInfo')}</h3>
                        <div className="tdm-info-grid">
                            <div className="tdm-info-item">
                                <span className="tdm-label">{t('details.dogName')}</span>
                                <span className="tdm-value">{training.dogDTO?.name || t('details.notAvailable')}</span>
                            </div>
                            <div className="tdm-info-item">
                                <span className="tdm-label">{t('details.breed')}</span>
                                <span className="tdm-value">{training.dogDTO?.breed || t('details.notAvailable')}</span>
                            </div>
                            <div className="tdm-info-item">
                                <span className="tdm-label">{t('details.owner')}</span>
                                <span className="tdm-value">{training.dogDTO?.ownerName || t('details.notAvailable')}</span>
                            </div>
                        </div>
                    </div>

                    {/* Training Information */}
                    <div className="tdm-section">
                        <h3 className="tdm-section-title">{t('details.trainingInfo')}</h3>
                        <div className="tdm-info-grid">
                            <div className="tdm-info-item">
                                <span className="tdm-label">{t('details.duration')}</span>
                                <span className="tdm-value">{t('details.durationMinutes', { minutes: duration })}</span>
                            </div>
                            {training.hallName && (
                                <div className="tdm-info-item">
                                    <span className="tdm-label">{t('details.hall')}</span>
                                    <span className="tdm-value">{training.hallName}</span>
                                </div>
                            )}
                            {training.serviceName && (
                                <div className="tdm-info-item">
                                    <span className="tdm-label">{t('details.service')}</span>
                                    <span className="tdm-value">{training.serviceName}</span>
                                </div>
                            )}
                            {training.price && (
                                <div className="tdm-info-item">
                                    <span className="tdm-label">{t('details.price')}</span>
                                    <span className="tdm-value">{t('details.priceValue', { amount: training.price })}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Additional Info */}
                    {training.additionalInfo?.additionalInfo && (
                        <div className="tdm-section">
                            <h3 className="tdm-section-title">{t('details.additionalInfo')}</h3>
                            <div className="tdm-additional-info">
                                {training.additionalInfo.additionalInfo}
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer with Actions */}
                <div className="tdm-footer">
                    <button
                        className="tdm-edit-btn"
                        onClick={() => {
                            onEdit(training);
                            onClose();
                        }}
                    >
                        {t('common:edit')}
                    </button>
                    <button
                        className="tdm-delete-btn"
                        onClick={() => {
                            onDelete(training);
                            onClose();
                        }}
                    >
                        {t('common:delete')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TrainingDetailsModal;